import React from 'react';

export default function CameraIcon({ active = false, off = false, size = 22, ...props }) {
  const stroke = active ? 'rgba(255,215,0,0.9)' : 'rgba(255,215,0,0.6)';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Viewfinder triangle */}
      <path d="M22 8l-5 4 5 4V8z" stroke={stroke} strokeWidth="1.6" strokeLinejoin="round" />
      {/* Camera body */}
      <rect x="2" y="6" width="14" height="13" rx="2.5" stroke={stroke} strokeWidth="1.6" />
      {/* Lens */}
      <circle cx="9" cy="12.5" r="3" stroke={stroke} strokeWidth="1.6" />
      {/* Slash-through when off */}
      {off && (
        <line x1="2" y1="2" x2="22" y2="22" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" />
      )}
    </svg>
  );
}
